import { render } from "./LocalitationIcon.vue?vue&type=template&id=1fbc47d0"
import script from "./LocalitationIcon.vue?vue&type=script&lang=js"
export * from "./LocalitationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__